import { ComponentPropsWithoutRef, forwardRef, useEffect, useState } from 'react';
import LogoDefault from '@static/images/menu/logo_default.svg';
import MobileLogoDefault from '@static/images/menu/mobile_logo_default.svg';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { Logo, LogoImg } from './styled';

interface IProps extends ComponentPropsWithoutRef<'a'> {
    providerId?: number,
    cityData: ICurrentCity,
    href: string,
    maxWidth?: string,
    className?: string,
}

const MenuLogo = forwardRef<HTMLAnchorElement, IProps>((
    { cityData, href, maxWidth, className },
    ref,
): JSX.Element => {
    const [logo, setLogo] = useState(cityData.logoFull);
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    useEffect(() => {
        isMobile
            ? setLogo(cityData.logo_narrow || MobileLogoDefault)
            : setLogo(cityData.logoFull || LogoDefault);
    }, [cityData, isMobile]);

    return (
        <Logo href={href} data-test='menu-logo' ref={ref} className={className}>
            <LogoImg
                data-test='menu-logo-img'
                src={logo}
                alt={'Логотип Дом.ру'}
                maxWidth={maxWidth}
            />
        </Logo>
    );
});
MenuLogo.displayName = 'ForwardedMenuLogo';
export default MenuLogo;
